import { BaseService } from './BaseService';
import { FetchResult } from 'apollo-link';
import { ApolloQueryResult } from 'apollo-client';
import deleteTaskMutation from '@/graphql/mutations/DeleteTask.gql';
import checkTaskMutation from '@/graphql/mutations/CheckTask.gql';
import upsertTasksMutation from '@/graphql/mutations/UpsertTasks.gql';
import updateTaskMutation from '@/graphql/mutations/UpdateTask.gql';
import fetchTasksQuery from '@/graphql/queries/FetchTasks.gql';
import {
  PaginationInput,
  TaskCheckInput,
  TaskFields,
  TaskInput,
  TaskScopedInput,
  TaskUpdateInput,
  deleteTask,
  fetchTasks
} from '@/types/graphql/schemaTypes';

class TaskService extends BaseService {
  public deleteTask(id: string): Promise<FetchResult<deleteTask>> {
    return this.client.mutate({
      mutation: deleteTaskMutation,
      variables: {
        id
      }
    });
  }

  public checkTasks(taskArgs: TaskCheckInput): Promise<FetchResult<TaskFields>> {
    return this.client.mutate({
      mutation: checkTaskMutation,
      variables: {
        taskArgs
      }
    });
  }

  public fetchTasks(
    args: TaskScopedInput,
    pagination?: PaginationInput | null
  ): Promise<ApolloQueryResult<fetchTasks>> {
    return this.client.query({
      query: fetchTasksQuery,
      variables: {
        pagination,
        searchArgs: args
      }
    });
  }

  public async updateTask(taskId: string, taskArgs: TaskUpdateInput) {
    const c = await this.client.mutate({
      mutation: updateTaskMutation,
      variables: {
        taskId,
        taskArgs
      }
    });
    return c;
  }

  public upsertTasks(
    shipmentId: string,
    tasksArgs: TaskInput[]
  ): Promise<FetchResult<TaskFields>> {
    return this.client.mutate({
      mutation: upsertTasksMutation,
      variables: {
        shipmentId,
        tasksArgs
      }
    });
  }
}

export const taskService = new TaskService();
